import HoldOn from 'react-hold-on';
import Swal from 'sweetalert2';
import moment from 'moment';
import $ from 'jquery';
import colors from './colors';

class Globals {

	hold_on_present = false;

	fromPhotos = (url: string) => {
		return process.env.REACT_APP_BASE_STORAGE + url;
	}

	fromStorage = (url: string) => {
		return process.env.REACT_APP_BASE_STORAGE + url;
	}

	setLoading = () => {
		if (!this.hold_on_present) {
			this.hold_on_present = true;
			HoldOn.open({
				theme: "sk-bounce"
			});
		}
	}

	quitLoading = () => {
		HoldOn.close();
		setTimeout(() => {
			this.hold_on_present = false;
		}, 500);
	}

	zeroPad = (num: any) => {
		return num.toString().padStart(6, "0");
	}

	formatMiles = (n: number, decimals = true, currency = '$'): string => {
		if (isNaN(n)) {
			return `${currency ? `${currency} ` : ''}0.00`;
		}
		n = Math.round(n * 100) / 100;

		const decimalPlaces = decimals ? 2 : 0;
		const decimalSeparator = ',';
		const thousandSeparator = '.';
		const sign = n < 0 ? '-' : '';
		const integerPart = Math.abs(n).toFixed(decimalPlaces);
		const [integer, fractional] = integerPart.split('.');
		const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
		const formattedNumber = `${sign}${formattedInteger}${decimalPlaces > 0 && fractional ? `${decimalSeparator}${fractional}` : ''
			}`;
		return `${currency ? `${currency} ` : ''}${formattedNumber}`;
	};

	hideTooltip = () => {
		$('button').blur();
		$('a').blur();
	}

	showSuccess = (message: string) => {
		Swal.fire({
			title: "",
			text: message,
			type: "success",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
		});
	}

	showHtml = (message: string) => {
		Swal.fire({
			title: "",
			html: message,
			type: "success",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
		});
	}

	showWarning = (message: string) => {
		Swal.fire({
			title: "",
			text: message,
			type: "warning",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
		});
	}

	showError = (message?: string) => {
		Swal.fire({
			title: "",
			text: message ? message : "Por favor, revise su conexión",
			type: "error",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
		});
	}

	confirm = (message: string, callback: any) => {
		this.hideTooltip();
		Swal.fire({
			title: "",
			text: message,
			type: "warning",
			showCancelButton: true,
			confirmButtonText: 'Aceptar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
		}).then((confirm: any) => {
			if (confirm.value) {
				callback();
			}
		});
	}

	clone = (data: any) => {
		return JSON.parse(JSON.stringify(data));
	}

	getDate = (date: string, to: string = 'DD/MM/YYYY', from: string = 'YYYY-MM-DD HH:mm:ss') => {
		return moment(date, from).format(to);
	}

	capitalize = (text: string) => {
		return text.charAt(0).toUpperCase() + text.slice(1);
	}

	isPdf(file: string) {
		return file.substr(file.lastIndexOf('.') + 1) == 'pdf';
	}

	isImage(file: string) {
		const formats = ['png', 'jpg', 'jpeg'];
		return formats.indexOf(file.substr(file.lastIndexOf('.') + 1)) != -1;
	}

	formatPercentage(amount: number) {
		return amount.toFixed(2) + '%';
	}

	pad(num: number | string, size = 4) {
		num = num.toString();
		while (num.length < size) num = "0" + num;
		return num;
	}

	convertDay = (day: number) => {
		switch (day) {
			case 1: return 'Lunes';
			case 2: return 'Martes';
			case 3: return 'Miércoles';
			case 4: return 'Jueves';
			case 5: return 'Viernes';
			case 6: return 'Sábado';
			case 7: return 'Domingo';
		}
	}

	validateEmail = (value: string) => {
      value = value.trim();
	  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	  return value.match(validRegex);
	}

	validateDouble(value: string) {
		return /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(value);
	}

	validateInteger(value: string) {
		return /^\d+$/.test(value);
	}

	getFileExtension(file: string) {
		return file.substring(file.lastIndexOf('.') + 1);
	}

	objectToQueryParams = (obj: any) => {
		const queryParams = [];

		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				const encodedKey = encodeURIComponent(key);
				const encodedValue = encodeURIComponent((Array.isArray(obj[key]) ? JSON.stringify(obj[key]) : obj[key]) || '');
				queryParams.push(`${encodedKey}=${encodedValue}`);
			}
		}

		return queryParams.join('&');
	}

	getInitials = (name: string, maxChars = 2) => {
		if (!name || typeof name !== 'string') return '??';

		// Elimina espacios múltiples, trim y divide por espacios
		const parts = name.trim().split(/\s+/);
		const initials = parts.map(part => part.charAt(0)).join('').substring(0, maxChars);

		return initials;
	}
}

export default new Globals();